import { StandardEvents } from '@shopify/events';

// Keep the original Horizon variant and cart behavior; refresh only our extra SKU fragment.
document.addEventListener(StandardEvents.productSelect, (event) => {
  if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
  const section = event.target.closest('.shopify-section');
  if (!section?.querySelector('.cb-product-page') || !event.promise) return;
  event.promise.then(({ detail }) => {
    if (!detail?.html) return;
    section.querySelectorAll('[data-cb-variant-fragment]').forEach((fragment) => {
      const key = fragment.getAttribute('data-cb-variant-fragment');
      const replacement = detail.html.querySelector(`[data-cb-variant-fragment="${CSS.escape(key)}"]`);
      if (replacement) fragment.replaceWith(replacement);
    });
  }).catch((error) => {
    if (error.name !== 'AbortError') console.warn('CubeBuff product information could not refresh.', error);
  });
});

class CubeBuffProductTabs extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.media = matchMedia('(min-width: 990px)');
    this.buttons = [...this.querySelectorAll('[data-cb-tab]')];
    this.panels = [...this.querySelectorAll('.cb-pdp-tab-detail')];
    this.active = 0;
    this.querySelector('.cb-pdp-tabs__buttons').addEventListener('click', (event) => {
      const button = event.target.closest('[data-cb-tab]');
      if (button) this.select(Number(button.dataset.cbTab));
    }, {signal:this.controller.signal});
    this.querySelector('.cb-pdp-tabs__buttons').addEventListener('keydown', (event) => {
      if (!['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : (this.active + 1) % 2;
      this.select(next);
      this.buttons[next].focus();
    }, {signal:this.controller.signal});
    this.media.addEventListener('change', () => this.layout(), {signal:this.controller.signal});
    this.layout();
  }
  disconnectedCallback() { this.controller?.abort(); }
  layout() {
    const desktop = this.media.matches;
    const list = this.querySelector('.cb-pdp-tabs__buttons');
    list.hidden = !desktop;
    this.dataset.desktop = String(desktop);
    if (desktop) list.setAttribute('role','tablist');
    else list.removeAttribute('role');
    this.buttons.forEach((button, index) => {
      const panel = this.panels[index];
      if (desktop) {
        button.setAttribute('role','tab');
        button.setAttribute('aria-controls', panel.id);
        panel.setAttribute('role','tabpanel');
        panel.setAttribute('aria-labelledby', button.id);
      } else {
        button.removeAttribute('role');
        panel.removeAttribute('role');
        panel.removeAttribute('aria-labelledby');
        panel.hidden = false;
        panel.open = false;
      }
    });
    if (desktop) this.select(this.active);
  }
  select(index) {
    this.active = index;
    this.buttons.forEach((button, i) => {
      button.setAttribute('aria-selected', String(i === index));
      button.tabIndex = i === index ? 0 : -1;
      this.panels[i].hidden = i !== index;
      this.panels[i].open = i === index;
    });
  }
}
if (!customElements.get('cb-product-tabs')) customElements.define('cb-product-tabs', CubeBuffProductTabs);
